export default __webpack_public_path__ + "static/media/C Sloth.ce55affd.png";